import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { InternalAuthService } from '../internal-auth.service';


@Component({
	selector: 'common-internal-signed-out',
	imports: [],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './internal-signed-out.widget.html'
})
export class CommonInternalSignedOutWidget {

	private readonly auth = inject(InternalAuthService);

	public signIn() {
		this.auth.internalSignIn();
	}
}
